/**
 * @file Contains utility functions that allow targeting pseudo-classes with props.
 * When used, allows props.active to act like :active, etc.
 *
 * When used, a preceding ampersand is needed.
 * `&${isHovered}${isNotActive}`
 */
import PseudoClassProps from 'design-system/types/PseudoClassProps';

export const isDisabled = ({ disabled }: PseudoClassProps) => (disabled ? '' : ':disabled');
export const isNotDisabled = ({ disabled }: PseudoClassProps) =>
  disabled ? ':not(*)' : ':not(:disabled)';

export const isHovered = ({ hovered }: PseudoClassProps) => (hovered ? '' : ':hover');
export const isNotHovered = ({ hovered }: PseudoClassProps) =>
  hovered ? ':not(*)' : ':not(:hover)';

export const isFocused = ({ focused }: PseudoClassProps) => (focused ? '' : ':focus');
export const isNotFocused = ({ focused }: PseudoClassProps) =>
  focused ? ':not(*)' : ':not(:focus)';

export const isActive = ({ active }: PseudoClassProps) => (active ? '' : ':focus-within');
export const isNotActive = ({ active }: PseudoClassProps) =>
  active ? ':not(*)' : ':not(:focus-within)';

export const isChecked = ({ checked }: PseudoClassProps) => (checked ? '' : ':checked');
